var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExclamation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 113.375C62.0437 113.375 59.513 112.322 57.4078 110.217C55.3026 108.112 54.25 105.581 54.25 102.625C54.25 99.6687 55.3026 97.138 57.4078 95.0328C59.513 92.9276 62.0437 91.875 65 91.875C67.9563 91.875 70.487 92.9276 72.5922 95.0328C74.6974 97.138 75.75 99.6687 75.75 102.625C75.75 105.581 74.6974 108.112 72.5922 110.217C70.487 112.322 67.9563 113.375 65 113.375ZM65 81.125C62.0437 81.125 59.513 80.0724 57.4078 77.9672C55.3026 75.862 54.25 73.3312 54.25 70.375V27.375C54.25 24.4187 55.3026 21.888 57.4078 19.7828C59.513 17.6776 62.0437 16.625 65 16.625C67.9563 16.625 70.487 17.6776 72.5922 19.7828C74.6974 21.888 75.75 24.4187 75.75 27.375V70.375C75.75 73.3312 74.6974 75.862 72.5922 77.9672C70.487 80.0724 67.9563 81.125 65 81.125Z",
    fill: "#FF7D24"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExclamation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Exclamation.acb1eecb.svg";
export { ForwardRef as ReactComponent };